// // custom animations
// const boxes = gsap.utils.toArray('.custom-fade-in');
// console.log(boxes);
// boxes.forEach((box, i) => {
//   const anim = gsap.fromTo(box, {autoAlpha: 0, y: 50}, {duration: 1, autoAlpha: 1, y: 0});
//   ScrollTrigger.create({
//     trigger: box,
//     animation: anim,
//     toggleActions: 'play none none none',
//     once: true,
//   });
// });

//header functionality

class MenuAnimation {
  constructor() {
    this.el = document.querySelector('.ext-menu-container');
    this.height = this.el.scrollHeight;
    this.el.style.setProperty('--max-height', this.height + 'px');

    this.button = document.querySelector('.header__icon-menu');
    if (this.button) {
      this.button.addEventListener('click', this.toggleMenu.bind(this));
    } else {
      console.log("Button does not exist.");
    }
  }

  toggleMenu() {
    const expandableEl = document.querySelector('div[data-quick-menu-expanded]');
    const expanded = expandableEl.dataset.quickMenuExpanded;
    const innerHeader = document.querySelector(".header__inner");

    if (expanded === 'true') {
      expandableEl.setAttribute('data-quick-menu-expanded', 'false');
      innerHeader.classList.remove('header__expanded');
    } else if (expanded === 'false') {
      expandableEl.setAttribute('data-quick-menu-expanded', 'true');
      innerHeader.classList.add('header__expanded');
    }
  }
}

// Create an instance of the MenuAnimation class
const menuAnimation = new MenuAnimation();

//scroll on the overview section
class ScrollAnimation {
  constructor() {
    this.lastScrollFirst = 0;
    this.elem = document.querySelector('.bd-animation');
    this.firstContainer = document.querySelector('[data-overview-product-container-first]');
    this.secondContainer = document.querySelector('[data-overview-product-container-second]');
    if(this.firstContainer){
      this.firstContainerWidth = this.firstContainer.scrollWidth - this.firstContainer.clientWidth;
    }
    this.initialScrollPercentage = null;

    this.handleScroll = this.handleScroll.bind(this);

    if(this.elem){
      this.attachScrollListener();
    }
  }
  

  attachScrollListener() {
    if (this.elem) {
      document.addEventListener('scroll', this.handleScroll);
    }
  }

  handleScroll() {
    const bounding = this.elem.getBoundingClientRect();

    if (bounding.top <= window.innerHeight && bounding.bottom >= 0) {
      let scrollPercentage = 1 - (bounding.bottom / window.innerHeight);
      scrollPercentage = Math.min(Math.max(scrollPercentage, 0), 1);

      // If it's the first time this element is in the viewport, remember this initial scroll percentage
      if (this.initialScrollPercentage === null) {
        this.initialScrollPercentage = scrollPercentage;
      }
      
      // Now we subtract the initial scroll percentage to always start from 0
      scrollPercentage -= this.initialScrollPercentage;

      const newScrollFirst = this.firstContainerWidth * scrollPercentage * 0.1;

      // Always update the scroll position, whether it's increasing or decreasing
      this.firstContainer.scrollLeft = newScrollFirst;
      if(this.secondContainer){
        this.secondContainer.scrollLeft = newScrollFirst * -1;
      }
      this.lastScrollFirst = newScrollFirst;
    } else {
      // Once the element is out of the viewport, we reset the initial scroll percentage
      this.initialScrollPercentage = null;
    }
  }
}


// Create an instance of the ScrollAnimation class
const productContainerElement = document.querySelector('.overview-product-container');

//NEW CHECKER MIKE - due to theme bug.
if (productContainerElement){
  const scrollAnimation = new ScrollAnimation();

  class ProductContainer {
    constructor(container) {
      this.container = container;
      this.productItems = Array.from(this.container.querySelectorAll('.overview-product-item'));
    }
  
    centerActiveItem() {
      const activeItem = this.productItems.find(item => item.classList.contains('active'));
  
      if (activeItem) {
        
        // Calculate the amount of scroll
        const scrollLeft = activeItem.offsetLeft 
                         - (this.container.offsetWidth / 2) 
                         + (activeItem.offsetWidth / 2);
                        
        // Scroll the container
        this.container.scrollLeft = scrollLeft;
      } else {
        console.log('No active product found.');
      }
    }
  }

  const productContainer = new ProductContainer(productContainerElement);
  productContainer.centerActiveItem();
  
}


  
//duft modal, mobile (live until 08/01, now standard ver.)
  document.addEventListener("DOMContentLoaded", function() {
    var triggerButton = document.querySelector(".duft-trigger button");
    var closeButton = document.querySelector(".duft-modal .close-button");
    var duftModal = document.querySelector(".duft-modal");
    var duftOverlay = document.querySelector(".duft-overlay");
    var contentElements = Array.from(document.querySelectorAll(".duft-modal .content *"));
  
    // Check if the elements exist in the DOM
    if(!triggerButton || !closeButton || !duftModal || !duftOverlay || contentElements.length === 0) {
      return;
    }
  
    function animateContent() {
      contentElements.forEach((el, i) => {
        el.style.animation = `slide-up-fade-in 0.5s ${(0.35 + i * 0.2)}s forwards`;
      });
    }
  
    function toggleModal() {
      if (duftModal.classList.contains("open")) {
        duftModal.classList.remove("open");
        duftOverlay.classList.remove("open");
        // document.documentElement.style.overflow = "auto";
        contentElements.forEach((el) => {
          el.style.animation = '';  // Reset the animation
        });
      } else {
        duftModal.classList.add("open");
        duftOverlay.classList.add("open");
        // document.documentElement.style.overflow = "hidden";
        animateContent();
      }
    }
  
    triggerButton.addEventListener("click", toggleModal);
    closeButton.addEventListener("click", toggleModal);
    duftOverlay.addEventListener("click", toggleModal);  // New event listener for overlay
  });


//desktop duft modal added.
document.addEventListener("DOMContentLoaded", function () {
  var triggerButton = document.querySelector(".desktop-only .duft-trigger button");
  var closeButton = document.querySelector(".desktop-only .duft-modal .close-button");
  var duftModal = document.querySelector(".desktop-only .duft-modal");
  var duftOverlay = document.querySelector(".desktop-only .duft-overlay");
  var contentElements = Array.from(document.querySelectorAll(".desktop-only .duft-modal .content *"));

  // Check if the elements exist in the DOM
  if (!triggerButton || !closeButton || !duftModal || !duftOverlay || contentElements.length === 0) {
    return false;
  }

  function animateContent() {
    contentElements.forEach((el, i) => {
      el.style.animation = `slide-up-fade-in 0.5s ${(0.35 + i * 0.2)}s forwards`;
    });
  }

  function toggleModal() {
    console.log("click from abt listener");
    if (duftModal.classList.contains("open")) {
      duftModal.classList.remove("open");
      duftOverlay.classList.remove("open");
      // document.documentElement.style.overflow = "auto";
      contentElements.forEach((el) => {
        el.style.animation = '';  // Reset the animation
      });
    } else {
      duftModal.classList.add("open");
      duftOverlay.classList.add("open");
      // document.documentElement.style.overflow = "hidden";
      animateContent();
    }
  }

  triggerButton.addEventListener("click", toggleModal);
  closeButton.addEventListener("click", toggleModal);
  duftOverlay.addEventListener("click", toggleModal);
});




